// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3oGzy","box":"WorkspacesBox_box__3HS_k","node":"WorkspacesBox_node__12zCx"};